<template>
    <div>
        <v-container grid-list-xl>
            <!-- kriterij iskanja -->
            <v-layout row wrap align-left justify-space-around fill-height>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-textarea
                    outlined
                    name="input-7-4"
                    label="Opombe"
                    v-model="msg"
                    counter
                    required
                    ></v-textarea>
                    <v-btn color="success" @click="print()">Test print :)</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        
    </div>
</template>

<script>

export default {
    data: () => ({
        msg: ""
    }),

    methods: {
        print () {
            navigator.bluetooth.requestDevice({
            acceptAllDevices: true,
                optionalServices: ['battery_service'] // Required to access service later.
            })
            .then(device => {
            console.log('device', device)
            if (device.gatt.connected) {
                device.gatt.disconnect()
            }
            console.log('connect')
                return this.connect(device)
            })
            .catch(this.handleError)
        },
        
        connect (device) {
        const self = this
        device.addEventListener('gattserverdisconnected', this.onDisconnected)
        return device.gatt
            .connect()
            .then(server =>
            server.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb')
            )
            .then(service =>
            service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb')
            )
            .then(characteristic => {
            console.log('characteristic', characteristic)
            self.printCharacteristic = characteristic
            self.sendTextData(device)
            })
            .catch(error => {
            this.handleError(error, device)
            })
        },
        handleError (error, device) {
        console.error('handleError => error', error)
        if (device != null) {
            device.gatt.disconnect()
        }
        let erro = JSON.stringify({
            code: error.code,
            message: error.message,
            name: error.name
        })
        console.log('handleError => erro', erro)
        if (error.code !== 8) {
            alert('Could not connect with the printer. Try it again')
        }
        },
        getBytes (text) {
        console.log('text', text)
        let br = '\u000A\u000D'
        text = text === undefined ? br : text
        let replaced = this.$languages.replace(text)
        console.log('replaced', replaced)
        let bytes = new TextEncoder('utf-8').encode(replaced + br)
        console.log('bytes', bytes)
        return bytes
        },
        addText (arrayText) {
        let text = this.msg
        arrayText.push(text)
        if (this.isMobile) {
            while (text.length >= 20) {
            let text2 = text.substring(20)
            arrayText.push(text2)
            text = text2
            }
        }
        },
        sendTextData (device) {
        let arrayText = []
        this.addText(arrayText)
        console.log('sendTextData => arrayText', arrayText)
        this.loop(0, arrayText, device)
        },
        loop (i, arrayText, device) {
        let arrayBytes = this.getBytes(arrayText[i])
        this.write(device, arrayBytes, () => {
            i++
            if (i < arrayText.length) {
            this.loop(i, arrayText, device)
            } else {
            let arrayBytes = this.getBytes()
            this.write(device, arrayBytes, () => {
                device.gatt.disconnect()
            })
            }
        })
        },
        write (device, array, callback) {
        this.printCharacteristic
            .writeValue(array)
            .then(() => {
            console.log('Printed Array: ' + array.length)
            setTimeout(() => {
                if (callback) {
                callback()
                }
            }, 250)
            })
            .catch(error => {
            this.handleError(error, device)
            })
        }
    },

    created() {
        navigator.bluetooth.getAvailability()
            .then(isBluetoothAvailable => {
                window.console.log(`> Bluetooth is ${isBluetoothAvailable ? 'available' : 'unavailable'}`);
            });

            if ('onavailabilitychanged' in navigator.bluetooth) {
            navigator.bluetooth.addEventListener('availabilitychanged', function(event) {
                window.console.log(`> Bluetooth is ${event.value ? 'available' : 'unavailable'}`);
            });
        }
    }
}

</script>

<style scoped>

</style>